module.exports = __webpack_public_path__ + "assets/87c4eb2dc7ed158a33dac577e1444557.mp3";